export const SAP_SYNC_STATUS = {
  PENDING: 'pending',
  PROCESSING: 'processing',
  COMPLETED: 'completed',
  FAILED: 'failed',
  DLQ: 'dlq',
} as const;

export const SAP_ENTITY_TYPES = {
  TENANT: 'tenant',
  SALES_ORDER: 'sales_order',
  WEIGHT_UPDATE: 'weight_update',
  MATERIAL: 'material',
  INVOICE: 'invoice',
  BALANCE: 'balance',
  PRICING: 'pricing',
  PAYMENT: 'payment',
} as const;

export const SAP_OPERATIONS = {
  CREATE_BUSINESS_PARTNER: 'create_business_partner',
  UPDATE_BUSINESS_PARTNER: 'update_business_partner',
  CHECK_CUSTOMER_EXISTS: 'check_customer_exists',
  PULL_BUSINESS_PARTNER: 'pull_business_partner',
  CREATE_SALES_ORDER: 'create_sales_order',
  CHECK_CUSTOMER_CONTRACT: 'check_customer_contract',
  CREATE_SALES_CONTRACT: 'create_sales_contract',
  WEIGHT_UPDATE_FIRST: 'weight_update_first',
  WEIGHT_UPDATE_SECOND: 'weight_update_second',
  PULL_PAYMENTS: 'pull_payments',
  PULL_INVOICES: 'pull_invoices',
} as const;

export const SAP_SYNC_DIRECTION = {
  OUTBOUND: 'outbound',
  INBOUND: 'inbound',
} as const;

export const CIRCUIT_BREAKER_STATE = {
  CLOSED: 'CLOSED',
  OPEN: 'OPEN',
  HALF_OPEN: 'HALF_OPEN',
} as const;

export const SAP_DASHBOARD_ENDPOINTS = {
  STATUS: '/api/sap-dashboard/status',
  DLQ: '/api/sap-dashboard/dlq',
  DLQ_RETRY: (id: number) => `/api/sap-dashboard/dlq/${id}/retry`,
  CIRCUIT_BREAKER: '/api/sap-dashboard/circuit-breaker',
  SYNC_JOBS: '/api/sap-sync-jobs',
  SYNC_JOB_DETAIL: (documentId: string) => `/api/sap-sync-jobs/${documentId}`,
} as const;

export const DEFAULT_PAGE_SIZE = 25;
